module.exports = "<div class=\"alert alert-error\" style=\"display: none;\"><%- errorMessage %></div>\n<p><%- message %></p>";